import type {
  ClaimRequestViewDto,
  DecideClaimInput,
  RequestClaimInfoInput,
} from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/**
 * Sahiplenme `api` katmanı — YALNIZCA sagalardan çağrılır (CLAUDE.md).
 *
 * Blok 8-1'de gölge etkinlik ürün modelinden kaldırıldı; talep edilecek sahipsiz
 * etkinlik üretilmediği için sahiplenmenin KULLANICI yüzeyi sunucuda kapatıldı.
 * Blok 8-2'de web tarafındaki sayfalar, nav bağlantısı ve ölü sarmalayıcılar da
 * silindi. GERİYE YALNIZCA moderasyon yüzeyi kaldı: admin kuyruğundaki tarihsel
 * talepler okunur ve karara bağlanır (denetlenebilirlik — CLAUDE.md).
 */

export async function fetchClaim(claimId: string): Promise<ClaimRequestViewDto> {
  return await api.claims.get(claimId);
}

/** Admin kararı (moderasyon panosu) — zorunlu gerekçe sunucuda Joi ile de doğrulanır. */
export async function decideClaim(
  claimId: string,
  input: DecideClaimInput,
): Promise<ClaimRequestViewDto> {
  return await api.claims.decide(claimId, input);
}

/** Admin ek bilgi isteği — talep durumu değişmez, talep sahibine e-posta gider. */
export async function requestClaimInfo(
  claimId: string,
  input: RequestClaimInfoInput,
): Promise<void> {
  await api.claims.requestInfo(claimId, input);
}
